const AdminSettingsPage = () => {
  return (
    <section className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
      <h2 className="text-xl font-bold text-gray-900">Settings</h2>
      <p className="mt-2 text-sm text-gray-600">
        Settings options will appear here as configuration features are added.
      </p>
    </section>
  );
};

export default AdminSettingsPage;
